<template>
  <div class="mod-config" style="height: 100% ">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item style="float: left;">
        <el-button @click="getMinutes" :type="buttonMinute">分钟值</el-button>
        <el-button @click="getHours" :type="buttonHour">小时值</el-button>
        <el-button @click="getDayAvgs" :type="buttonAverage">日均值</el-button>
      </el-form-item>
      <el-form-item style="float: left;" label="选择时间：">
        <el-date-picker
          :picker-options="dataForm.pickerOptions"
          v-model="dataForm.dateStr"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :format="dataForm.formatTime"
          :value-format="dataForm.formatTime"
          :default-time="['00:00:00','23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-button @click="getDataList()" type="primary" icon="el-icon-search" style="float: left;"></el-button>
      <el-form-item style="float: right;">
        <el-button size="mini" icon="el-icon-back" @click="returnd()" style="font-size: 18px;"></el-button>
        <el-button size="mini" v-show="isShow" class="el-icon-s-marketing" @click="echarts()"
                   style="font-size: 18px;"></el-button>
        <el-button size="mini" v-show="isShow" style="font-size: 18px;" @click="reload()"><i
          class="el-icon-refresh"></i></el-button>
        <el-button type="success" @click="recordExcel()">导出Excel</el-button>
      </el-form-item>
    </el-form>
    <div style="clear: both;display: block;text-align: left;font-weight: bold;font-size: 16px;">
      <label>所属企业：</label>
      <span style="font-weight: initial;min-width: 250px;display: inline-block">{{ssqy}}</span>
      <label>所属点位：</label>
      <span style="font-weight: initial;">{{ssdw}}</span>
      <br>
      <label>设备名称：</label>
      <span style="font-weight: initial;min-width: 250px;display: inline-block">{{sbmc}}</span>
      <label>唯一编码：</label>
      <span style="font-weight: initial;">{{wybm}}</span>
    </div>
<!--    <p class="list-p" v-if="dataList == null || dataList.length === 0 ">-->
<!--      <i class="el-icon-warning"></i>-->
<!--      {{ msg }}-->
<!--    </p>-->
    <el-table
      v-if="this.type == 0"
      :key="Math.random()"
      :data="dataList"
      v-loading="dataListLoading"
      v-show="isShow"
      style="width: 100%;" height="calc(100% - 166px)" border stripe
      :header-cell-style="{background:'#364a5f',color:'#fff'}" placement="top">
      <el-table-column
        width="204"
        sortable
        prop="device_record_time"
        header-align="center"
        align="center"
        label="记录时间">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHead"
        :key="index"
        header-align="center"
        align="center"
        :label="item.title"
        :prop="item.field">
      </el-table-column>
    </el-table>
    <el-table
      v-else
      :key="Math.random()"
      :data="dataList"
      v-loading="dataListLoading"
      v-show="isShow"
      style="width: 100%;height:calc(100% - 166px);" border stripe
      :header-cell-style="{background:'#364a5f',color:'#ffffff'}" placement="top">
      <el-table-column
        width="204"
        sortable
        prop="device_record_time"
        header-align="center"
        align="center"
        label="记录时间">
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHead"
        :key="index"
        header-align="center"
        align="center"
        :label="item.title"
        :prop="item.field">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[15, 24, 60, 100]"
      :page-size="pageSize"
      :total="totalPage"
      v-show="isShow"
      layout="prev, pager, next, jumper, total,sizes">
    </el-pagination>
    <!-- 图表 -->
    <div  id="datams">
      <label>数据模式：</label>
      <el-select  v-model="region" placeholder="请选择活动区域" @change="sjms">
        <el-option label="分页模式" value="shanghai"></el-option>
        <el-option label="全数据模式" value="beijing"></el-option>
      </el-select>
    </div>

    <div id="yhecharts">

    </div>
  </div>
</template>
<style scoped>
.list-p{
  clear: both;
  height: calc(100% - 130px);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
#datams {
  position: absolute;
  z-index: 99999;
  right: 18px;
  top: 50px;
  display: none;
}
#yhecharts {
  width: 100%;
  height: calc(100% - 124px);
  position: absolute;
  top: 114px;
  z-index: 9999;
  display: none;
  background: #fff;
}
/deep/ .el-table__body-wrapper {
  overflow-y: scroll;
  height: calc(100% - 70px);
}
/deep/ .el-table td, /deep/ .el-table th.is-leaf {
  padding: 0 !important;
}
/deep/ .el-table .cell {
  padding: 0 !important;
  height: 64px !important;
  line-height: 64px !important;
}
</style>
<script>
import $ from 'jquery'
import {excel} from "@/utils";
//全局的chart变量接收
var myChart;
export default {
  data() {
    return {
      region: '分页模式',
      dataForm: {
        params: '',
        dateEnum: '',
        dateStr: '',
        dateFromStr: '',
        dateToStr: '',
        formatTime:"yyyy-MM-dd HH:mm",
        pickerOptions: {
          disabledDate(time) {
              //一天的毫秒数=86400000
              return time.getTime()  > new Date()
          }
        }
      },
      //分钟、小时、日|0-1-3
      type: 0,
      number: '1',
      dataList: [],
      tableHead: [],
      pageIndex: 1,
      pageSize: 60,
      totalPage: 0,
      isShow: true,
      msg: '',
      dataListLoading: false,
      buttonMinute: 'primary',
      buttonHour: '',
      buttonAverage: '',
      sbmc:"",
      ssqy:"",
      ssdw:"",
      wybm:"",
      eightaveraged: {
        legend: [],
        series: [
          {
            name: "", type: "line", sampling:"average",stack: "总量", data: [],
          }
        ],
        xaxis: [],
        time:''
      },
      colspan:''
    }
  },
  created() {
    this.time = this.$moment(new Date()).add(1, "days").toDate()
    //动态设置默认时间
    this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH:mm"),
      this.$moment(new Date()).add(1, "days").format("yyyy-MM-DD  HH:mm")]
    this.getMinutes();
    // this.getDataList();
  },
  methods: {
    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex > 0) {
        if(row.deviceId == null){
          return {
            rowspan: 1,
            colspan: this.colspan
          };
        }
      }
    },
    sjms(event){
      if(event == "shanghai"){
        this.getDataList();
      }else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.$message.warning("请选择要查询的时间")
        }
        this.$http({
          url: this.$http.adornUrl("/device/record/echarts/all"),
          method: "get",
          params: this.$http.adornParams({
            'deviceId': this.$route.query.id,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.type,
          })
        }).then(({data}) => {
          loading.close();
          if (data && data.code === 200) {
            if (data.data.length !== 0) {
              this.eightaveraged = data.data.echarts;
              // 基于准备好的dom，初始化echarts实例 绘制图表
              document.getElementById('yhecharts').innerHTML = "";
              document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
              myChart = this.$echarts.init(document.getElementById('yhecharts'))
              myChart.setOption({
                tooltip: {
                  trigger: 'axis',
                  textStyle: {
                    align:'left'
                  },
                  axisPointer: {
                    lineStyle: {
                      color: '#57617B'
                    }
                  }
                },
                color:["#FFE4B5","#FFA500","#ff0000","#ADFF2F","#00FFFF",
                  "#FF7F50","#00FF7F","#FFFF00","#FF4500","#ff1493",
                  "#98FB98","#9400D3","#00FF00","#F5F5DC","#FFE4E1","#F0E68C",
                  "#7FFF00","#FF69B4","#F0FFFF","#FFD700","#FA8072","#F0FFF0","#FFF0F5","#FAFAD2"],
                legend: {
                  type: 'scroll',
                  icon: "circle",
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 15,
                  data: this.eightaveraged.legend,
                  left: "4%",
                  right: "4%",
                  top:"30",
                  textStyle: {
                    color: "#000",
                    fontSize: 20
                  }
                },
                grid: {
                  containLabel: true,
                  left: "4%",
                  right: "4%",
                  top: '12%',
                  bottom: "8%"
                },
                dataZoom: [
                  {
                    type: 'inside',
                    start: 0,
                    end: 20
                  },
                  {
                    start: 0,
                    end: 20
                  }
                ],
                xAxis: {
                  type: 'category',
                  data: this.eightaveraged.xaxis,
                  axisLine: { //  改变x轴颜色
                    show: false,
                    lineStyle: {
                      color: '#26D9FF'
                    }
                  },
                  axisLabel: { //  改变x轴字体颜色和大小
                    textStyle: {
                      color: "000",
                      fontSize: 14
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: false,
                  }
                },
                yAxis: {
                  type: 'value',
                  // name: "(浓度值)",
                  axisLine: { //  改变y轴颜色
                    show: false,
                    lineStyle: {
                      color: '#000'
                    }
                  },
                  axisLabel: { //  改变y轴字体颜色和大小
                    //formatter: '{value} m³ ', //  给y轴添加单位
                    textStyle: {
                      color: "#000",
                      fontSize: 14
                    },
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#314a63'],
                    }
                  }
                },
                series: this.eightaveraged.series
              });
              window.addEventListener("resize", function () {
                myChart.resize();
              });
            } else {
              //查询成功，但暂无数据
              this.isShow = false
              if (myChart) {
                myChart.clear()
              }
              $("#yhecharts").hide();
              $("#datams").hide();
            }
          } else {
          }
        });
      }
    },

    //格式化
    dateFormat(row, column) {
      let date = row[column.property];
      return this.$moment(date).format("YYYY年MM月DD日")
    },
    // 获取数据列表
    getDataList() {
      if(this.type == 0){
        //时间条件
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.$message.warning("请选择要查询的时间")
        }
        this.dataListLoading = true;
        this.dataList = [];
        this.tableHead = [];
        this.$http({
          url: this.$http.adornUrl('device/record/lst'),
          method: 'get',
          params: this.$http.adornParams({
            'pageNum': this.pageIndex,
            'pageSize': this.pageSize,
            'deviceId': this.$route.query.id,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.type,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            //当查询有数据时
            if (data.data.length !== 0) {
              this.isShow = true
              this.tableHead = data.data.head;
              this.dataList = data.data.rows;
              this.sbmc = data.data.info.name;
              this.ssqy = data.data.info.companyName;
              this.ssdw = data.data.info.address;
              this.wybm = data.data.info.code;
              this.totalPage = data.data.total;
              this.eightaveraged = data.data.echarts;
              this.colspan = Object.keys( data.data.head).length;
              document.getElementById('yhecharts').innerHTML = "";
              document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
              // 基于准备好的dom，初始化echarts实例 绘制图表
              myChart = this.$echarts.init(document.getElementById('yhecharts'))
              myChart.setOption({
                tooltip: {
                  trigger: 'axis',
                  textStyle: {
                    align:'left'
                  },
                  axisPointer: {
                    lineStyle: {
                      color: '#57617B'
                    }
                  }
                },
                color:["#FFE4B5","#FFA500","#ff0000","#ADFF2F","#00FFFF",
                  "#FF7F50","#00FF7F","#FFFF00","#FF4500","#ff1493",
                  "#98FB98","#9400D3","#00FF00","#F5F5DC","#FFE4E1","#F0E68C",
                  "#7FFF00","#FF69B4","#F0FFFF","#FFD700","#FA8072","#F0FFF0","#FFF0F5","#FAFAD2"],
                legend: {
                  type: 'scroll',
                  icon: "circle",
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 15,
                  data: this.eightaveraged.legend,
                  left: "4%",
                  right: "4%",
                  top:"30",
                  textStyle: {
                    color: "#000",
                    fontSize: 20
                  }
                },
                grid: {
                  containLabel: true,
                  left: "4%",
                  right: "4%",
                  top: '12%',
                  bottom: "4%"
                },
                xAxis: {
                  type: 'category',
                  data: this.eightaveraged.xaxis,
                  axisLine: { //  改变x轴颜色
                    show: false,
                    lineStyle: {
                      color: '#26D9FF'
                    }
                  },
                  axisLabel: { //  改变x轴字体颜色和大小
                    textStyle: {
                      color: "000",
                      fontSize: 14
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: false,
                  }
                },
                yAxis: {
                  type: 'value',
                  // name: "(浓度值)",
                  axisLine: { //  改变y轴颜色
                    show: false,
                    lineStyle: {
                      color: '#000'
                    }
                  },
                  axisLabel: { //  改变y轴字体颜色和大小
                    //formatter: '{value} m³ ', //  给y轴添加单位
                    textStyle: {
                      color: "#000",
                      fontSize: 14
                    },
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#314a63'],
                    }
                  }
                },
                series: this.eightaveraged.series
              });
              window.addEventListener("resize", function () {
                myChart.resize();
              });
            } else {
              //查询成功，但暂无数据
              this.isShow = false
              if (myChart) {
                myChart.clear()
              }
              $("#yhecharts").hide();
              $("#datams").hide();
            }
          } else {
            this.dataList = []
            this.totalPage = 0
            this.$message.warning(data.msg)
          }
          this.msg = data.msg
          this.dataListLoading = false
        })
      }else {
        //时间条件
        if (this.dataForm.dateStr) {
          this.dataForm.dateFromStr = this.dataForm.dateStr[0]
          this.dataForm.dateToStr = this.dataForm.dateStr[1]
        } else {
          this.$message.warning("请选择要查询的时间")
        }
        this.dataListLoading = true;
        this.dataList = [];
        this.tableHead = [];
        this.$http({
          url: this.$http.adornUrl('/device/record/lst'),
          method: 'get',
          params: this.$http.adornParams({
            'pageNum': this.pageIndex,
            'pageSize': this.pageSize,
            'deviceId': this.$route.query.id,
            'dateFromStr': this.dataForm.dateFromStr,
            'dateToStr': this.dataForm.dateToStr,
            'dateEnum': this.type,
          })
        }).then(({data}) => {
          if (data && data.code === 200) {
            //当查询有数据时
            if (data.data.length !== 0) {
              this.isShow = true
              this.tableHead = data.data.head;
              this.dataList = data.data.rows;
              this.sbmc = data.data.info.name;
              this.ssqy = data.data.info.companyName;
              this.ssdw = data.data.info.address;
              this.wybm = data.data.info.code;
              this.totalPage = data.data.total;
              this.eightaveraged = data.data.echarts;
              document.getElementById('yhecharts').innerHTML = "";
              document.getElementById("yhecharts").removeAttribute("_echarts_instance_");
              // 基于准备好的dom，初始化echarts实例 绘制图表
              myChart = this.$echarts.init(document.getElementById('yhecharts'))
              myChart.setOption({
                tooltip: {
                  trigger: 'axis',
                  textStyle: {
                    align:'left'
                  },
                  axisPointer: {
                    lineStyle: {
                      color: '#57617B'
                    }
                  }
                },
                color:["#FFE4B5","#FFA500","#ff0000","#ADFF2F","#00FFFF",
                  "#FF7F50","#00FF7F","#FFFF00","#FF4500","#ff1493",
                  "#98FB98","#9400D3","#00FF00","#F5F5DC","#FFE4E1","#F0E68C",
                  "#7FFF00","#FF69B4","#F0FFFF","#FFD700","#FA8072","#F0FFF0","#FFF0F5","#FAFAD2"],
                legend: {
                  type: 'scroll',
                  icon: "circle",
                  itemWidth: 15,
                  itemHeight: 15,
                  itemGap: 15,
                  data: this.eightaveraged.legend,
                  left: "4%",
                  right: "4%",
                  top:"30",
                  textStyle: {
                    color: "#000",
                    fontSize: 20
                  }
                },
                grid: {
                  containLabel: true,
                  left: "4%",
                  right: "4%",
                  top: '12%',
                  bottom: "4%"
                },
                xAxis: {
                  type: 'category',
                  data: this.eightaveraged.xaxis,
                  axisLine: { //  改变x轴颜色
                    show: false,
                    lineStyle: {
                      color: '#26D9FF'
                    }
                  },
                  axisLabel: { //  改变x轴字体颜色和大小
                    textStyle: {
                      color: "000",
                      fontSize: 14
                    }
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: false,
                  }
                },
                yAxis: {
                  type: 'value',
                  // name: "(浓度值)",
                  axisLine: { //  改变y轴颜色
                    show: false,
                    lineStyle: {
                      color: '#000'
                    }
                  },
                  axisLabel: { //  改变y轴字体颜色和大小
                    //formatter: '{value} m³ ', //  给y轴添加单位
                    textStyle: {
                      color: "#000",
                      fontSize: 14
                    },
                  },
                  axisTick: {
                    show: false
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ['#314a63'],
                    }
                  }
                },
                series: this.eightaveraged.series
              });
              window.addEventListener("resize", function () {
                myChart.resize();
              });
            } else {
              //查询成功，但暂无数据
              this.isShow = false
              if (myChart) {
                myChart.clear()
              }
              $("#yhecharts").hide();
              $("#datams").hide();
            }
          } else {
            this.dataList = []
            this.totalPage = 0
            this.$message.warning(data.msg)
          }
          this.msg = data.msg
          this.dataListLoading = false
        })
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    //excel
    recordExcel() {
      //时间条件
      if (this.dataForm.dateStr) {
        this.dataForm.dateFromStr = this.dataForm.dateStr[0]
        this.dataForm.dateToStr = this.dataForm.dateStr[1]
      } else {
        this.$message.warning("请选择要查询的时间")
      }
      const loading = this.$loading({
        lock: true,
        text: '导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      excel("/device/record/excel", this.sbmc + "-" + this.$moment(new Date()).format("yyyyMMDDHHmm"), {
        'pageNum': this.pageIndex,
        'pageSize': this.pageSize,
        'deviceId': this.$route.query.id,
        'dateFromStr': this.dataForm.dateFromStr,
        'dateToStr': this.dataForm.dateToStr,
        'dateEnum': this.type,
      },loading.close(),this.$message({
          message: '导出成功',
          type: 'success',
          duration: 3000,
          offset: '50%',
          showClose:true,
          onClose: () => {}
        })
      )
    },
    returnd() {
        this.$router.replace({path: '/indexhome/device'});
    },
    //  分钟值
    getMinutes() {
      this.dataForm.formatTime = "yyyy-MM-dd HH:mm";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH:mm"),
        this.$moment(new Date()).format("yyyy-MM-DD HH:mm")]
      this.pageSize = 60;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.type = 0
      this.buttonMinute = 'primary';
      this.buttonHour = '';
      this.buttonAverage = ''
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
    },
    //小时值
    getHours() {
      this.dataForm.formatTime = "yyyy-MM-dd HH";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD HH"),
        this.$moment(new Date()).format("yyyy-MM-DD HH")]
      this.pageSize = 24;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.type = 1
      this.buttonMinute = '';
      this.buttonHour = 'primary';
      this.buttonAverage = '';
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
    },
    //日均值
    getDayAvgs() {
      this.dataForm.formatTime = "yyyy-MM-dd";
      //动态设置默认时间
      this.dataForm.dateStr = [this.$moment(new Date()).add(-8, "days").format("yyyy-MM-DD"),
        this.$moment(new Date()).add(-1, "days").format("yyyy-MM-DD")]
      this.pageSize = 15;
      if (this.number == "1") {
      } else {
        this.echarts();
      }
      this.type = 3
      this.buttonMinute = '';
      this.buttonHour = '';
      this.buttonAverage = 'primary';
      if (this.dataForm.dateStr) {
        this.getDataList();
      }
      // this.getDataList();
    },
    reload() {
      this.number = '1';
      $(".el-table--border").show();
      $(".el-pagination").show();
      $("#yhecharts").hide();
      $("#datams").hide();
      this.getDataList();
    },
    echarts() {
      this.number = '0';
      myChart.resize();
      $("#yhecharts").show();
      $("#datams").show();
      $(".el-table--border").hide();
      $(".el-table--border").hide();
      $(".el-pagination").hide();
      myChart.resize();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/deviceDetailRecordView.vue